import React, { Component } from "react";
import _ from "lodash";
import anime from "animejs";

// import styled, { keyframes } from "styled-components";
import PhuketMasterplan from "../../containers/ProjectMap/PhuketMasterplan";
import commonLogos from "../../containers/ProjectMap/common-logos";
import { multiLanguage } from "../../hoc";
import { getHeaderHeight } from "../../utils/navigation";
import { isIE } from "../../utils/detector";
import { scroller } from "react-scroll";

import Bubble from "./components/Bubble";

// Filter LVR logo
const logos = _.reject(commonLogos, (logo) => logo.key === "laguna-beachside");

// const bounce = keyframes`
//   0% {
//     transform: scale(0);
//   }
//   20% {
//     transform: scale(1);
//   }
//   40% {
//     transform: scale(0.7);
//   }
//   60% {
//     transform: scale(1);
//   }
//   100% {
//     transform: scale(1);
//   }
// `;

// const AnimatedBubble = styled.g`
//   cursor: pointer;
//   animation-name: ${bounce};
//   animation-duration: 3s;
//   animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
//   animation-iteration-count: infinite;
// `;

const filterTexts = (texts) => {
  return _.filter(texts, (text, i) => {
    const excludeList = _.get(text, "options.excludes", []);
    if (
      _.includes(excludeList, "lpark2/masterplan") ||
      _.includes(excludeList, "masterplan")
    )
      return false;
    return true;
  });
};

const fixIETransform = (id) => (anim) => {
  const g = document.getElementById(id);
  if (g) {
    const transform = getComputedStyle(g).getPropertyValue("transform");
    g.setAttribute("transform", transform);
  }
};

@multiLanguage()
export default class Masterplan extends Component {
  componentDidMount() {
    anime({
      targets: "#laguna-beachside-bubble",
      scale: [
        { value: 0, duration: 0, elasticity: 0 },
        { value: 1, duration: 2000, elasticity: 400 },
      ],
      loop: true,
      update: isIE ? fixIETransform("laguna-beachside-bubble") : null,
    });
  }
  handleClickBubble = () => {
    // go to master plan
    const headerHeight = getHeaderHeight();
    scroller.scrollTo("siteplan", {
      duration: 1500,
      smooth: true,
      offset: -headerHeight,
    });
  };
  render() {
    const { t, currentLanguage } = this.props;
    // console.log('filterTexts >>> ', filterTexts);
    return (
      <div className="section-masterplan">
        <PhuketMasterplan
          activeLanguage={currentLanguage}
          filterTexts={filterTexts}
        >
          <g transform="translate(250, 230)">
            <g id="laguna-beachside-bubble" onClick={this.handleClickBubble}>
              <Bubble />
            </g>
          </g>
        </PhuketMasterplan>
        <div className="masterplan-name">{t("Master Plan")}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/LagunaBeachside/Masterplan.js